"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var redux_persist_1 = require("redux-persist");
var server_1 = require("../../../../helpers/server");
var HourControlActions_1 = require("./HourControlActions");
// Initial state values
var initialState = {
    weekHours: [],
    selectedUsersLogs: {},
    selectedWeekDay: null,
    userLogsCalculating: false,
    usersGPSInfo: {},
    approvedWeeks: [],
    isApproving: false,
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.WEEK_HOURS).success:
            return __assign(__assign({}, state), { weekHours: action.payload.results });
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.WORKLIG_LIST).request: {
            return __assign(__assign({}, state), { userLogsCalculating: true });
        }
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.WORKLIG_LIST).success: {
            return __assign(__assign({}, state), { selectedUsersLogs: action.payload.results, userLogsCalculating: false });
        }
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.GET_USER_LOG).success: {
            return __assign(__assign({}, state), { selectedUsersLogs: updateUserLogs(state.selectedUsersLogs, action.payload) });
        }
        case HourControlActions_1.HourControlActions.SELECT_WEEK:
            return __assign(__assign({}, state), { selectedWeekDay: action.payload });
        case HourControlActions_1.HourControlActions.ADD_WORKLOG: {
            return __assign(__assign({}, state), { selectedUsersLogs: updateUserLogs(state.selectedUsersLogs, action.payload) });
        }
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.SAVE_LOG_IN_SERVER).success: {
            return __assign(__assign({}, state), { selectedUsersLogs: updateUserLogs(state.selectedUsersLogs, action.payload) });
        }
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.APPROVE_USER_HOURS).request: {
            return __assign(__assign({}, state), { isApproving: true });
        }
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.APPROVE_USER_HOURS).success: {
            return __assign(__assign({}, state), { approvedWeeks: updateApprovedWeeks(state.approvedWeeks, action.payload), isApproving: false });
        }
        case (0, server_1.apiActions)(HourControlActions_1.HourControlActions.APPROVE_USER_HOURS).fail: {
            return __assign(__assign({}, state), { isApproving: false });
        }
        /* ------------- LOGOUT  ------------------- */
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        /* ------------- END  LOGOUT  ------------------- */
        default:
            return state;
    }
});
var updateApprovedWeeks = function (approvedWeeks, payload) {
    return __spreadArray(__spreadArray([], approvedWeeks, true), payload, true);
};
// When does query for a day not in system, update the new logs from database
var updateUserLogs = function (selectedUserLogs, payload) {
    var _a;
    if (!selectedUserLogs[payload.userId]) {
        selectedUserLogs[payload.userId] = { user: { _id: payload.userId }, worklogs: [] };
    }
    if (!payload.results[payload.userId]) {
        return __assign({}, selectedUserLogs);
    }
    var newLogs = payload.results[payload.userId].worklogs;
    // Reset the logs of this day (filter out and concatenate news)
    var currentWorkLogs = _.chain(selectedUserLogs[payload.userId].worklogs)
        .filter(function (worklogs) { return worklogs.date_worked !== payload.day; })
        .concat(newLogs)
        // Lets avoid extra reload create duplicates
        .uniqBy('_id')
        .value();
    return __assign(__assign({}, selectedUserLogs), (_a = {}, _a[payload.userId] = __assign(__assign({}, selectedUserLogs[payload.userId]), { worklogs: __spreadArray([], currentWorkLogs, true) }), _a));
};
